import ScoreByHourOfDayBarChart from './ScoreByHourOfDayBarChart';
export default ScoreByHourOfDayBarChart;



// WEBPACK FOOTER //
// ./src/components/ScoreByHourOfDayBarChart/index.js